import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import classnames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import { Link } from 'react-router-dom';
import style from './index.scss';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../pages/constants/globalConstants';

const HitModal = ({
  subTheadData,
  activeBU,
  topInfoMetadata,
  isShown,
  data,
  selectedRow,
  onCloseAlert,
  toggleAssignModal,
  toggleHitModal
}) => {
  if (!data || !data.hits || !isShown || !topInfoMetadata) {
    return <div />;
  }

  const modalDataTopInfo = data;
  const subheaderLength = subTheadData.length;
  const subTbodyData = data.hits || [];
  const subTbodyLengh = subTbodyData.length;

  //modal selected hit data
  const subTbodySelectedRowData = subTbodyData[selectedRow] || {};

  let leftPanel = [];
  for (let i = 0; i < topInfoMetadata.left.length; i++) {
    const item = topInfoMetadata.left[i];
    let topLeftInfoData = modalDataTopInfo;

    if (item['alert_key'].includes('.')) {
      // determine the path within the object to access the value
      const keyPath = item['alert_key'].split('.');
      keyPath.map((key) => {
        topLeftInfoData = topLeftInfoData[key];
      });
    }

    // Else, use the name as is to access the value
    if (!item['alert_key'].includes('.')) {
      topLeftInfoData = modalDataTopInfo[item['alert_key']];
    }

    leftPanel.push(
      <div className={style.formGroup}>
        <div className="col-md-4">
          <label className={style.groupLabel}>{item['label']}:</label>
        </div>
        <div className="col-md-4">
          <span className={style.valuePair1}>{topLeftInfoData}</span>
        </div>
        <div className="col-md-4">
          <span className={style.valuePair2}>
            {subTbodySelectedRowData[item['hit_key']]}
          </span>
        </div>
      </div>
    );
  }

  let rightPanel = [];
  for (let i = 0; i < topInfoMetadata.right.length; i++) {
    const item = topInfoMetadata.right[i];

    let topRightInfoData = modalDataTopInfo;

    if (item['alert_key'].includes('.')) {
      // determine the path within the object to access the value
      const keyPath = item['alert_key'].split('.');
      keyPath.map((key) => {
        topRightInfoData = topRightInfoData[key];
      });
    }

    // Else, use the name as is to access the value
    if (!item['alert_key'].includes('.')) {
      topRightInfoData = modalDataTopInfo[item['alert_key']];
    }

    rightPanel.push(
      <div className={style.formGroup}>
        <div className="col-md-4">
          <label className={style.groupLabel}>{item['label']}:</label>
        </div>
        <div className="col-md-4">
          <span className={style.valuePair1}>{topRightInfoData}</span>
        </div>
        <div className="col-md-4">
          <span className={style.valuePair2}>
            {subTbodySelectedRowData[item['hit_key']]}
          </span>
        </div>
      </div>
    );
  }

  //build modal information
  let subTheadCols = [];
  for (let i = 0; i < subheaderLength; i++) {
    const item = subTheadData[i];

    let groupCols = [];
    item.group.forEach((col, k) => {
      groupCols.push(
        <span key={`subheader-${i}-col-${k}`} className={style.headerSubCol}>
          {col.value}
        </span>
      );
    });

    subTheadCols.push(
      <div key={`subheader-${i}`} className={style.headerCol}>
        {item.value}
        {groupCols}
      </div>
    );
  }

  let subTbodyRows = [];
  for (let i = 0; i < subTbodyLengh; i++) {
    const rowItem = subTbodyData[i];

    let subTbodyCols = [];
    for (let j = 0; j < subheaderLength; j++) {
      const colItem = subTheadData[j];

      let groupRowCols = [];
      colItem.group.forEach((subColItem, k) => {
        let groupSubColVal = rowItem;

        if (subColItem.name.includes('.')) {
          // determine the path within the object to access the value
          const keyPath = subColItem.name.split('.');
          keyPath.map((key) => {
            groupSubColVal = groupSubColVal[key];
          });
        }

        // Else, use the name as is to access the value
        if (!subColItem.name.includes('.')) {
          groupSubColVal = rowItem[subColItem.name];
        }

        if (typeof groupSubColVal == 'object') {
          groupSubColVal = groupSubColVal?.value ? groupSubColVal.value : '';
        }

        groupRowCols.push(
          <span
            key={`subBodyrow-${i}-col-${j}-subcol-${k}`}
            className={style.bodySubCol}>
            {groupSubColVal}
          </span>
        );
      });

      let subColVal = rowItem;

      if (colItem.name.includes('.')) {
        // determine the path within the object to access the value
        const keyPath = colItem.name.split('.');
        keyPath.map((key) => {
          subColVal = subColVal[key];
        });
      }

      // Else, use the name as is to access the value
      if (!colItem.name.includes('.')) {
        subColVal = rowItem[colItem.name];
      }

      subTbodyCols.push(
        <div key={`row-${i}-subcol-${j}`} className={classnames(style.bodyCol)}>
          {subColVal}
          {groupRowCols}
        </div>
      );
    }

    subTbodyRows.push(
      <div
        key={`secondRow-${i}`}
        onClick={() => {
          this.onHitRowSelected(i);
        }}
        className={classnames(
          style.secondRow,
          i === selectedRow ? style.selectedRow : ''
        )}>
        {subTbodyCols}
      </div>
    );
  }

  return (
    <Modal
      isOpen={isShown}
      toggle={() => toggleHitModal()}
      backdrop={false}
      size="xl"
      contentClassName="newModalContent">
      <ModalBody>
        <div className={style.modalTopInfo}>
          <div className="row">
            <div className="col-md-6">{leftPanel}</div>
            <div className="col-md-6">{rightPanel}</div>
          </div>
        </div>
        <Scrollbars style={{ height: 240 }}>
          <div style={{ width: subheaderLength * 140 }}>
            <div className={style.secondTableHeader}>{subTheadCols}</div>
            <div className={style.tableBody}>{subTbodyRows}</div>
          </div>
        </Scrollbars>
      </ModalBody>
      <ModalFooter>
        {modalDataTopInfo['status'] !== 'Closed' ? (
          <button className={style.actionBtn} onClick={(e) => onCloseAlert(e)}>
            Close Alert
          </button>
        ) : (
          ''
        )}
        <Link
          className={style.actionBtn}
          to={`${ROUTE_AMLS_SMART_SCREENING}/investigation/${modalDataTopInfo['id']}?bu_id=${activeBU}`}>
          Investigate
        </Link>
        {modalDataTopInfo['investigator']?.['name'] ? (
          ''
        ) : (
          <button
            className={style.actionBtn}
            onClick={(e) => toggleAssignModal(e)}>
            Assign
          </button>
        )}
        <button className="btn btn-tertiary" onClick={() => toggleHitModal()}>
          Cancel
        </button>{' '}
      </ModalFooter>
    </Modal>
  );
};

export default HitModal;
